// src/store/slices/houseSettingsSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/AxiosInstance";

export const fetchOtherSettingsThunk = createAsyncThunk(
  "houseSettings/fetchOther",
  async (home_id, { rejectWithValue }) => {
    try {
      const res = await api.get(`/api/house-settings/other/${home_id}`);
      if (!res.data?.success) return rejectWithValue(res.data?.message || "Failed");
      return res.data?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err.message || "Server error");
    }
  }
);

export const updateOtherSettingsThunk = createAsyncThunk(
  "houseSettings/updateOther",
  async ({ home_id, payload }, { rejectWithValue }) => {
    try {
      const res = await api.put(`/api/house-settings/other/${home_id}`, payload);
      if (!res.data?.success) return rejectWithValue(res.data?.message || "Failed");
      return res.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err.message || "Server error");
    }
  }
);

const houseOtherSettingsSlice = createSlice({
  name: "houseOtherSettings",
  initialState: {
    other: null,
    loadingOther: false,
    savingOther: false,
    error: null,
    successMsg: null,
  },
  reducers: {
    clearHouseSettingsMsg: (s) => {
      s.error = null;
      s.successMsg = null;
    },
  },
  extraReducers: (b) => {
    b.addCase(fetchOtherSettingsThunk.pending, (s) => {
      s.loadingOther = true;
      s.error = null;
      s.successMsg = null;
    });
    b.addCase(fetchOtherSettingsThunk.fulfilled, (s, a) => {
      s.loadingOther = false;
      s.other = a.payload || null;
    });
    b.addCase(fetchOtherSettingsThunk.rejected, (s, a) => {
      s.loadingOther = false;
      s.error = a.payload || "Failed";
    });

    b.addCase(updateOtherSettingsThunk.pending, (s) => {
      s.savingOther = true;
      s.error = null;
      s.successMsg = null;
    });
    b.addCase(updateOtherSettingsThunk.fulfilled, (s, a) => {
      s.savingOther = false;
      s.successMsg = a.payload?.message || "Saved";
    });
    b.addCase(updateOtherSettingsThunk.rejected, (s, a) => {
      s.savingOther = false;
      s.error = a.payload || "Failed";
    });
  },
});

export const { clearHouseSettingsMsg } = houseOtherSettingsSlice.actions;
export default houseOtherSettingsSlice.reducer;
